import { useTranslation } from "@i18n";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";

interface AttachFilesProps {
  onCancelClick: () => void;
  /** Wired to a button's `onClick`, so it receives the click event. */
  onAcceptClick: (e: React.SyntheticEvent | null) => void;
}

function AttachFiles({ onCancelClick, onAcceptClick }: AttachFilesProps) {
  const { t } = useTranslation();
  return (
    <div className="fixed start-0 top-[4.6875rem] z-[21] flex h-full w-full items-center justify-center overflow-scroll bg-black/40">
      <div className="flex w-[29.25rem] flex-col gap-3 bg-white p-4 text-sm">
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold">{t("Attach Files")}</div>
          <span className="cursor-pointer" onClick={onCancelClick}>
            {"✕"}
          </span>
        </div>
        <div>
          {t(
            "The issue(s) that you have selected are associated to the file(s). You can only transmit issues if the associated files are also being transmitted as a part of the same transmittal.",
          )}
        </div>
        <div className="flex gap-3">
          <ButtonComponent buttonType="gradientButton" onClick={onAcceptClick} cssClass="e-info">
            {t("Attach Files")}
          </ButtonComponent>
          <ButtonComponent onClick={onCancelClick} cssClass="e-flat">
            {t("Cancel")}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

export default AttachFiles;
